export default ["NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA", "ACT"];
